import { User as SupabaseUser } from "@supabase/supabase-js";

class User {
  id: null | string;

  email: undefined | string;

  public static fromJSON(data: Record<string, any>): User {
    const user = new User();
    user.id = data.id;
    user.email = data.email;
    return user;
  }

  public static fromSupabaseUser(supabaseUser: SupabaseUser): User {
    // first try to fetch from `new_email` because when a guest account is converted to a permanent
    // account, the new email is stored in new_email until the session is refreshed
    const email = supabaseUser.new_email || supabaseUser.email;

    return User.fromJSON({ id: supabaseUser.id, email });
  }
}

export default User;
